import { render, staticRenderFns } from "./SupportNotificationsBell.vue?vue&type=template&id=36c83c02&scoped=true&"
import script from "./SupportNotificationsBell.vue?vue&type=script&lang=js&"
export * from "./SupportNotificationsBell.vue?vue&type=script&lang=js&"
import style0 from "./SupportNotificationsBell.vue?vue&type=style&index=0&id=36c83c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c83c02",
  null
  
)

export default component.exports